export default "__VITE_ASSET__CUEkx9u7__"